module.exports = "/images/calendar.svg?298b5b94c4c279eb1943737b5b618f7a";